import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StickyBuildingReveal from './components/StickyBuildingReveal';
import HorizontalProjectGallery from './components/HorizontalProjectGallery';
import Gallery from './components/Gallery';
import AboutSection from './components/AboutSection';
import QuickLinks from './components/QuickLinks';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <StickyBuildingReveal />
      <HorizontalProjectGallery />
      <Gallery />
      <AboutSection />
      <QuickLinks />
      <Footer />
    </div>
  );
}